import { ASSETS_LOCATIONS, getAssetsUrl } from '../../../utilities/constants';
export const TIMER_MODAL_CONTENT_IMAGES = {
  CLOSE: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'close.svg'),
  BOOKING_EXPIRED: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'booking-expired.svg'),
  BOOKING_ABOUT_TO_EXPIRED: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'booking-about-to-expires.svg')
};
